import { ChartSettings } from './chart-settings';
import { ChartType } from './chart-type.enum';
import { CustomizableChartParameters } from './customizable-chart-parameters';

export class CustomizableChartSettings extends ChartSettings {
  dataParameters: CustomizableChartParameters;
  chartType: ChartType = ChartType.customizable;

  constructor(init: CustomizableChartSettings) {
    super(init);
    Object.assign(this, init);
  }
}
